import React, { useEffect } from 'react';
export function SitemapXml() {
  const content = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>https://viridiaanalytics.com/</loc>
    <priority>1.0</priority>
    <changefreq>weekly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/how-it-works</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/getting-started</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/why</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/pricing</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/contact</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/case-studies</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/case-studies/tfp-landscaping</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/case-studies/finish-coat-painting</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/blog</loc>
    <changefreq>weekly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/blog/how-to-choose-marketing-agency</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/blog/why-response-time-makes-or-breaks-your-yelp-ads</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/blog/faster-yelp-replies-more-landscaping-estimates</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/blog/ai-receptionist-vs-human-receptionist-cost</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/blog/missed-call-text-back-phoenix-home-services</loc>
    <changefreq>monthly</changefreq>
  </url>
  <url>
    <loc>https://viridiaanalytics.com/tools/gmail-signature-generator</loc>
    <changefreq>monthly</changefreq>
  </url>
</urlset>`;
  useEffect(() => {
    document.title = 'sitemap.xml';
    const meta = document.querySelector('meta[name="robots"]');
    if (meta) meta.remove();
  }, []);
  return <pre style={{
    position: 'fixed',
    inset: 0,
    zIndex: 99999,
    background: 'white',
    color: 'black',
    padding: '1rem',
    margin: 0,
    fontFamily: 'monospace',
    fontSize: '14px',
    whiteSpace: 'pre-wrap',
    lineHeight: 1.5
  }} data-id="element-2793" data-mp="x6i9ldiczi0o">
      {content}
    </pre>;
}